import classNames from 'classnames';
import React, { useContext } from 'react';
import useSWR from 'swr';
import { useLocation } from 'react-router-dom';

import { userContext } from 'contexts/userContext';
import useEnv from 'hooks/useEnv';
import { fetcher } from 'services/fetcher';
import { gtmAfiEventLab } from 'services/gtm';
import { Site } from 'types/Site';

type PropsType = {
  classes?: ClassesType;
};

type ClassesType = {
  container?: string;
};

/**
 * Octipas Footer. Return by Site.cxml API.
 */
function Footer({ classes }: PropsType): JSX.Element | null {
  const { datetimeApp } = useEnv();
  const { pathname } = useLocation();
  const { gtmUserCookie } = useContext(userContext);
  const { data } = useSWR<Site>(
    `${process.env.REACT_APP_URL_API_CATALOG}/json/Custom/Site.cxml?${datetimeApp}`,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
    }
  );

  const htmlContent = data?.Zones[2]?.Controls[0]?.Actions[0]?.HtmlContent;

  if (!htmlContent) {
    return null;
  }

  function handleOnClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    const { target } = ev;
    const segments = pathname.split('/');

    const link = target.closest('a');
    if (link.href) {
      if (segments[2] === '' && target.closest('.oct_reassBlock')) {
        gtmAfiEventLab(
          pathname,
          'afiEventLab',
          'Footer',
          'Départ page réassurance',
          gtmUserCookie,
          link.title
        );
      }
      window.location = link.href;
    }
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      onClick={ev => handleOnClick(ev)}
      className={classNames(classes?.container)}
    />
  );
}

export default Footer;
